module.exports = __webpack_public_path__ + "static/media/interface.e0253793.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/interface.svg
// module id = 163
// module chunks = 0